import { PageHeader, WhatIsThis } from '@/components/primitives'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card'
import { flattenLeaves } from '@/lib/nav'
import { Construction } from 'lucide-react'
import { useLocation } from 'react-router-dom'

interface PlaceholderPageProps {
  title?: string
  description?: string
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  const location = useLocation()
  const leaf = flattenLeaves().find((l) => l.to === location.pathname)
  const resolvedTitle = title ?? leaf?.title ?? 'Section'

  return (
    <div className="space-y-2">
      <PageHeader
        title={resolvedTitle}
        description={
          description ??
          'This part of the admin panel is on the roadmap. The plan and timing are below.'
        }
      />
      <WhatIsThis>
        While this section is being built, you can still reach the legacy Django
        Admin at{' '}
        <code className="rounded bg-muted px-1 py-0.5 text-xs">/admin/</code>.
        Once we ship it, the same data will live here with a friendlier
        interface.
      </WhatIsThis>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="flex size-10 items-center justify-center rounded-lg bg-muted">
              <Construction className="size-5 text-muted-foreground" />
            </div>
            <div className="flex-1">
              <CardTitle>Coming soon</CardTitle>
              <CardDescription>
                The plan for this section is in{' '}
                <code className="rounded bg-muted px-1 py-0.5 text-xs">
                  phases/*.md
                </code>
                .
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>
            Nothing here yet — but the foundation is in place. Search the
            sidebar (top of the left rail) to jump to other sections.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
